<template>
    <div>
        <template v-if="crud_vendor_category === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Vendor Categories</h1>
                <router-link to="/addVendorCategory" class="btn btn-primary float-right active"> Add New Vendor Category</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" autocomplete="off" />
                </div>
            </div>
                
            <table id="vendorCategoryTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th style="display: none;"></th>
                        <th>Vendor Category</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-if="crud_vendor_category === null"><preLoader></preLoader></template>
        <template v-if="crud_vendor_category === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                crud_vendor_category : null,
            };
        },
        mounted() {
          var gThat = this;
            this.$Progress.start();
            this.can('crud_vendor_category').then(result=>{
                this.crud_vendor_category = result.crud_vendor_category;
            }).then(result=>{
                if(this.crud_vendor_category == true){
                    this.getVendorCategories();                    
                }
            });
          window.softDelete = function(vendorCategoryId){
            gThat.softDelete(vendorCategoryId);
          }
        },
        methods: {
            getVendorCategories(){
                var vendorCategoryTable = $('#vendorCategoryTable').DataTable({
                    processing: true,
                    serverSide: true,
                    // searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listVendorCategories",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editVendorCategory/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i></a></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                        }}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                    
                });
                $('#customSearch').on( 'keyup', function () {
                    vendorCategoryTable.search(this.value).draw();
                });
            },
          softDelete(vendorCategoryId) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/vendorCategoriesSoftDelete", {VendorCategoryId: vendorCategoryId})
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','VendorCategory deleted successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        },
        created() {
            // 
        }        
    }
</script>
